<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12">
        <TextField v-model="integrations['google-tag-manager']" label="Google Tag Manager"/>      
      </v-col>

      <v-col cols="12" class="_pt">
        <TextField v-model="integrations['google-analytics']" label="Google Analytics"/>      
      </v-col>

      <v-col cols="12" class="_pt">
        <TextField v-model="integrations['facebook-pixel']" label="Facebook Pixel"/>      
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import TextField from '../../../_v2/ui/TextField.vue'

export default {
  props: {
    integrations: { type: Object }
  },
  components: { TextField },

  computed: {
    ...mapGetters(["infos", "saveConfig"]),
  },

  created() {
    this.integrations;
  },

  methods: {
    save() {
      // this.saveConfig();
    },
  },
};
</script>

<style scoped>
* {
  font-family: Inter, sans-serif !important;
}
.titleColor {
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0.15000000596046448px;
  text-align: left;
  color: #192b46;
}
</style>
